export default __webpack_public_path__ + "static/media/ic-weight-scale.4440e158.svg";